import { reduxKey } from './constants';
import { BiStore } from './types';
import { createSelector } from 'reselect';
import { getPublicSession } from '../../publicSession/selectors';

function getBiStore(state): BiStore {
  return state[reduxKey] || { pageview: {} };
}

export function getPageBiContext(state) {
  return getBiStore(state).pageview;
}

export const getPageViewAndComponent = createSelector(
  [getPageBiContext],
  ({ component, view }) => {
    return { component, view };
  }
);

export function getBiContextData(state) {
  return { ...getPublicSession(state), ...getPageViewAndComponent(state) };
}
